export const JOB_STATUS = {
  PENDING: 'pending',
  DELIVERED: 'delivered',
  EVALUATED: 'evaluated',
};

export const SUBMITTED_JOB_STATUSES = [JOB_STATUS.DELIVERED, JOB_STATUS.EVALUATED];
